import { get } from "../../service/api";

const getActiveMerchantInvoice = async (merchantId) => {
  try {
    const response = await get(`/merchant/${merchantId}/activeMerchantInvoice`);
    return response.data;
  } catch (error) {
    console.error("Error getActiveMerchantInvoice:", error);
    throw error;
  }
};

export default getActiveMerchantInvoice;
